import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles';
import FullScreenDialog from './FullScreenDialog'
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
// import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
// import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Avatar from '@material-ui/core/Avatar';
import { Card, CardContent, ListItem, ListItemAvatar, ListItemText, Typography } from '@material-ui/core';
import moment from 'moment'
import { ValidatorForm, TextValidator, SelectValidator } from 'react-material-ui-form-validator';
// import SignatureCanvas from 'react-signature-canvas'
import SignatureField from './SignatureField'
import ValidationProblemsDialog from './ValidationProblemsDialog'
import ConfirmationDialog from './ConfirmationDialog'
import uuid from 'react-uuid'
import haversine from 'haversine'


const styles = (theme) => {
    return ({
        card: {
            marginBottom: '20px'
        },
        cardTitle: {
            marginLeft: '15px',
            marginTop: '15px',
        },
    })
};

class VisitForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // current_date_time_start: null,
            current_date_time_end: null,
            // current_location_start: null,
            current_location_end: null,
            current_duration: 0,
            // current_duration_diff: 0,
            current_units: 1,
            isStarted: !props.data.actual_date_end && props.data.actual_date_start? true: false,
            // buttonText: 'Start',
            isButtonDisabled: props.data.actual_date_end? true: false,
            setIntervalHandler: null,
            readonly: props.data.state === 'submitted' ? true : false,
            data: {
                ...props.data,
            },
            signatureWidth: 550,
            signatureHeight: 150,
            is_validation_dialog_open: false,
            validation_problems: [],
            validation_promise_handlers: null,
            is_confirmation_dialog_open: false,
            confirmation_promise_handlers: null,
            confirmation_dialog_title: 'Alert',
            confirmation_dialog_content: 'Are you sure?',
        }

        this.form = React.createRef();
        this.visit_caregiver_signature = React.createRef();
        this.provider_signature = React.createRef();
        this.visit_caregiver_signature_canvas = React.createRef();
        this.provider_signature_canvas = React.createRef();
    }

    handleChange = (e) => {
        console.log(e.target.name);
        console.log(e.target.value);
        const new_data = {
            ...this.state.data,
            [e.target.name]: e.target.value
        }
        switch (e.target.name) {
            case 'recipient_id':
                if (!new_data.recipient_signature_by_id) {
                    const recipient = this.props.recipients[e.target.value][0];
                    const index = Object.keys(recipient.possible_recipient_signature_by_ids).find(key => recipient.possible_recipient_signature_by_ids[key] === 'Legal Guardian');
                    if (index) {
                        new_data.recipient_signature_by_id = index
                    }
                }
                break;
            case 'units':
            case 'date_start':
            case 'time_start':
                if (new_data.date_start && new_data.time_start) {
                    if (!new_data.units)
                        new_data.units = 0

                    let end_datetime = moment(new_data.date_start + ' ' + new_data.time_start).add(parseInt(new_data.units) * 15, 'minutes')

                    // ('YYYY-MM-DD HH:mm:ss')
                    new_data.date_end = end_datetime.format('YYYY-MM-DD')
                    new_data.time_end = end_datetime.format('HH:mm')
                }
                break;

            default:
                break;
        }

        this.setState({
            data: new_data
        })
    }

    handleSignatureChange = (e) => {
        this.setState({
            ...this.state,
            data: {
                ...this.state.data,
                [e.current.props.name]: e.current.toDataURL()
            }
        })
    }

    handle_validation_continue = e => {
        this.state.validation_promise_handlers.resolve()
        this.setState({
            is_validation_dialog_open: false
        })
    }

    do_start_validations = position => {
        let promise_handlers = {}
        const promise = new Promise((res, rej) => {
            promise_handlers.resolve = res
            promise_handlers.reject = rej
        })
        const validation_problems = []


        let now = moment()
        let scheduled = moment(this.state.data.date_start + ' ' + this.state.data.time_start)
        let diff = Math.abs(now - scheduled)
        if(diff !== 0){
            diff /= 1000 * 60 * 60

            if(diff > 1){
                validation_problems.push({
                    id: uuid(),
                    type: 'warning',
                    description: 'Scheduled and Actual start time differs in more than an hour.'
                })
            }
        }
            
        if(!this.state.data.recipient_id || !this.state.data.end_address_id){
            validation_problems.push({
                id: uuid(),
                type: 'danger',
                description: 'Please fill the required fields in the form.'
            })
        }
        else{
            const start_address = this.props.recipients[this.state.data.recipient_id][0].address.find(x => x.id === this.state.data.end_address_id)
            if(start_address && (!start_address.latitude || !start_address.longitude)){
                validation_problems.push({
                    id: uuid(),
                    type: 'warning',
                    description: 'No location information is defined in the address.'
                })
            }

            if(start_address.latitude && start_address.longitude){
                const distance = haversine(position.coords, {latitude: parseFloat(start_address.latitude), longitude: parseFloat(start_address.longitude)}, {unit: 'mile'})
                if(distance > 1){
                    validation_problems.push({
                        id: uuid(),
                        type: 'warning',
                        description: 'The current position is more than a mile away from the selected address (' + distance.toFixed(2) + ' mile(s)).'
                    })
                }
            }
        }

        if(validation_problems.length){
            this.setState({
                is_validation_dialog_open: true,
                validation_promise_handlers: promise_handlers,
                validation_problems
            })
        }
        else{
            promise_handlers.resolve()
        }
        

        return promise
    }

    do_end_validations = position => {
        let promise_handlers = {}
        const promise = new Promise((res, rej) => {
            promise_handlers.resolve = res
            promise_handlers.reject = rej
        })
        const validation_problems = []


        let now = moment()
        let scheduled = moment(this.state.data.date_end + ' ' + this.state.data.time_end)
        let diff = Math.abs(now - scheduled)
        if(diff !== 0){
            diff /= 1000 * 60 * 60

            if(diff > 1){
                validation_problems.push({
                    id: uuid(),
                    type: 'warning',
                    description: 'Scheduled and Actual end time differs in more than an hour.'
                })
            }
        }
            
        if(!this.state.data.recipient_id || !this.state.data.end_address_id){
            validation_problems.push({
                id: uuid(),
                type: 'danger',
                description: 'Please fill the required fields in the form.'
            })
        }
        else{
            const end_address = this.props.recipients[this.state.data.recipient_id][0].address.find(x => x.id === this.state.data.end_address_id)
            if(end_address && (!end_address.latitude || !end_address.longitude)){
                validation_problems.push({
                    id: uuid(),
                    type: 'warning',
                    description: 'No location information is defined in the address.'
                })
            }

            if(end_address.latitude && end_address.longitude){
                const distance = haversine(position.coords, {latitude: parseFloat(end_address.latitude), longitude: parseFloat(end_address.longitude)}, {unit: 'mile'})
                if(distance > 1){
                    validation_problems.push({
                        id: uuid(),
                        type: 'warning',
                        description: 'The current position is more than a mile away from the selected address (' + distance.toFixed(2) + ' mile(s)).'
                    })
                }
            }
        }

        if(validation_problems.length){
            this.setState({
                is_validation_dialog_open: true,
                validation_promise_handlers: promise_handlers,
                validation_problems
            })
        }
        else{
            promise_handlers.resolve()
        }
        

        return promise
    }

    handleValidationProblemsDialogClose = e => {
        this.state.validation_promise_handlers.reject()
        this.setState({
            is_validation_dialog_open: false
        })
    }

    handleStopButtonClick = e => {
        const debug = true

        this.setState({
            ...this.state,
            isStarted: false,
            // buttonText: '...',
            isButtonDisabled: true
        }, async () => {
            let position = null

            // obtiene posisicion
            try {
                position = await new Promise((resolve, reject) => {
                    if (navigator.geolocation) {
                        navigator.geolocation.getCurrentPosition(resolve, reject, {
                            timeout: 10000
                        });
                    }
                })
            }
            catch(error){
                console.info(error);
                if (error.code === window.GeolocationPositionError.POSITION_UNAVAILABLE || error.code === window.GeolocationPositionError.TIMEOUT) {
                    console.info('No encuentro posiscion');
                }
                else if (error.code === window.GeolocationPositionError.PERMISSION_DENIED) {
                    console.info('acceso denegado');
                }

                if (debug) {
                    position = {
                        coords: {
                            longitude: 0,
                            latitude: 0
                        }
                    }
                }
            }

            if(position){
                // valida
                try{
                    // espera por la desicion del usuario de continuar si hay errores
                    await this.do_end_validations(position)
                    // si el usuario continua o no hay errores
                    this.process_position(position)
                    this.setState({
                        data: {
                            ...this.state.data,
                            visit_state: 'Completed'
                        }
                    }, this.form.current.submit)
                }
                catch(e){
                    // si hay errores y se cancela el dialogo q muestra los problemas
                    this.setState({
                        ...this.state,
                        isStarted: true,
                        isButtonDisabled: false
                    })
                }
            }
            else {
                this.setState({
                    ...this.state,
                    isStarted: true,
                    isButtonDisabled: false
                })
            }



            // new Promise((resolve, reject) => {
            //     if (navigator.geolocation) {
            //         navigator.geolocation.getCurrentPosition(resolve, reject, {
            //             timeout: 10000
            //         });
            //     }
            // })
            //     .then(position => {
            //         this.process_position(position)
            //         this.setState({
            //             ...this.state,
            //             // buttonText: this.state.isStarted ? 'Stop' : 'Start',
            //             // isButtonDisabled: false
            //         })
            //     })
            //     .catch(error => {
            //         console.info(error);
            //         if (error.code === window.GeolocationPositionError.POSITION_UNAVAILABLE || error.code === window.GeolocationPositionError.TIMEOUT) {
            //             console.info('No encuentro posiscion');
            //         }
            //         else if (error.code === window.GeolocationPositionError.PERMISSION_DENIED) {
            //             console.info('acceso denegado');
            //         }

            //         if (debug) {
            //             this.setState({
            //                 ...this.state,
            //                 // buttonText: this.state.isStarted ? 'Stop' : 'Start',
            //                 // isButtonDisabled: false
            //             })
            //             this.process_position({
            //                 coords: {
            //                     longitude: 0,
            //                     latitude: 0
            //                 }
            //             })
            //         }
            //         else {
            //             this.setState({
            //                 ...this.state,
            //                 isStarted: true,
            //                 // buttonText: !this.state.isStarted ? 'Stop' : 'Start',
            //                 isButtonDisabled: false
            //             })
            //         }
            //     })
        })
    }

    handleStartButtonClick = e => {
        const debug = true

        this.setState({
            ...this.state,
            isStarted: true,
            isButtonDisabled: true
        }, async () => {

            let position = null

            // obtiene posisicion
            try {
                position = await new Promise((resolve, reject) => {
                    if (navigator.geolocation) {
                        navigator.geolocation.getCurrentPosition(resolve, reject, {
                            timeout: 10000,
                        });
                    }
                })
            }
            catch(error){
                console.info(error);
                if (error.code === window.GeolocationPositionError.POSITION_UNAVAILABLE || error.code === window.GeolocationPositionError.TIMEOUT) {
                    console.info('No encuentro posiscion');
                }
                else if (error.code === window.GeolocationPositionError.PERMISSION_DENIED) {
                    console.info('acceso denegado');
                }

                if (debug) {
                    position = {
                        coords: {
                            longitude: 0,
                            latitude: 0
                        }
                    }
                }
            }

            if(position){
                // valida
                try{
                    // espera por la desicion del usuario de continuar si hay errores
                    await this.do_start_validations(position)
                    // si el usuario continua o no hay errores
                    this.process_position(position)
                    this.setState({
                        data: {
                            ...this.state.data,
                            visit_state: 'In Progress'
                        },
                        isButtonDisabled: false
                    }, this.form.current.submit)
                }
                catch(e){
                    // si hay errores y se cancela el dialogo q muestra los problemas
                    this.setState({
                        ...this.state,
                        isStarted: false,
                        isButtonDisabled: false
                    })
                }
            }
            else {
                this.setState({
                    ...this.state,
                    isStarted: false,
                    isButtonDisabled: false
                })
            }
        })
    }

    handleSave = e => {
        // valida form
        this.form.current.submit()
    }

    // handleVisitSubmit = e => {
    //     // valida form
    //     this.setState({
    //         data: {
    //             ...this.state.data,
    //             state: 'submitted'
    //         }
    //     }, () => {
    //         this.form.current.submit()
    //     })
    // }

    handleVisitCancel = async e => {

        const confirmation_promise_handlers = {}

        const promise = new Promise((resolve, reject) => {
            confirmation_promise_handlers.resolve = resolve
            confirmation_promise_handlers.reject = reject
        })

        this.setState({
            is_confirmation_dialog_open: true,
            confirmation_promise_handlers
        })

        try{
            await promise
            this.setState({
                data: {
                    ...this.state.data,
                    visit_state: 'Cancelled'
                },
                is_confirmation_dialog_open: false
            }, () => {
                this.form.current.submit()
            })
        }
        catch(e){
            this.setState({
                is_confirmation_dialog_open: false
            })
        }
    }

    handleSubmit = e => {
        this.props.handleSave({
            ...this.state.data,
        })
    }

    componentWillUnmount(){
        clearInterval(this.state.setIntervalHandler);
    }

    componentDidMount(){
        if(this.state.isStarted){
            this.start_counter()
        }
    }

    start_counter = () => {
        console.log('start_counter', this.state.setIntervalHandler);
        clearInterval(this.state.setIntervalHandler);
        const setIntervalHandler = setInterval(() => {
            const interval_now = moment()
            console.log('interval', interval_now.format('HH:mm:ss'));

            this.setState({
                ...this.state,
                // data: {
                //     ...this.state.data,
                //     actual_date_end: interval_now.format('YYYY-MM-DD'),
                //     actual_time_end: interval_now.format('HH:mm:ss'),
                // }
                interval_now
            })
        }, 1000)

        this.setState({
            ...this.state,
            // current_date_time_start: now,
            // current_location_start: location,
            setIntervalHandler,

            
        })
    }

    process_position = (position) => {

        var now = moment()
        // const location = position['coords']['latitude'] + ', ' + position['coords']['longitude']

        if (!this.state.isStarted) {
            console.log('cerrando interval');
            clearInterval(this.state.setIntervalHandler);

            this.setState({
                data: {
                    ...this.state.data,
                    actual_date_end: now.format('YYYY-MM-DD'),
                    actual_time_end: now.format('HH:mm:ss'),
                    actual_end_latitude: position['coords']['latitude'],
                    actual_end_longitude: position['coords']['longitude'],
                },
                setIntervalHandler: null,
            })
        }
        else {
            this.start_counter()

            this.setState({
                data: {
                    ...this.state.data,
                    actual_date_start: now.format('YYYY-MM-DD'),
                    actual_time_start: now.format('HH:mm:ss'),
                    actual_start_latitude: position['coords']['latitude'],
                    actual_start_longitude: position['coords']['longitude'],
                }
            })
        }
    }

    render() {

        const { classes } = this.props;
        const visit = this.state.data

        const recipientSelectElements = []
        for (const recipient_id in this.props.recipients) {
            if (this.props.recipients.hasOwnProperty(recipient_id)) {
                const x = this.props.recipients[recipient_id][0];
                recipientSelectElements.push(
                    <MenuItem value={x.id} key={x.id}>
                        <ListItem>
                            <ListItemAvatar>
                                <Avatar alt={x.name} src={'data:image/png;base64,' + x.image_small} />
                            </ListItemAvatar>
                            <ListItemText primary={x.name}></ListItemText>
                        </ListItem>
                    </MenuItem>
                )
            }
        }

        const addressSelectElements = []
        if (visit.recipient_id) {
            for (const address of this.props.recipients[visit.recipient_id][0].address) {
                addressSelectElements.push(
                    <MenuItem value={address.id} key={address.id}>
                        <ListItem>
                            <ListItemText primary={address.street1}></ListItemText>
                        </ListItem>
                    </MenuItem>
                )
            }
        }

        const caregiverSignatureSelectElements = []
        if (visit.recipient_id) {
            const possible_recipient_signature_by_ids = this.props.recipients[visit.recipient_id][0].possible_recipient_signature_by_ids
            for (const id in possible_recipient_signature_by_ids) {
                if (possible_recipient_signature_by_ids.hasOwnProperty(id)) {
                    const item = possible_recipient_signature_by_ids[id];
                    caregiverSignatureSelectElements.push(
                        <MenuItem value={id} key={id}>
                            <ListItem>
                                <ListItemText primary={item}></ListItemText>
                            </ListItem>
                        </MenuItem>
                    )
                }
            }
        }

        let current_duration_diff = 0
        if(visit.actual_date_start && visit.actual_time_start){

            let now
            if(visit.actual_date_end && visit.actual_time_end){
                now = moment(visit.actual_date_end + ' ' + visit.actual_time_end)
            }
            else{
                now = this.state.interval_now
            }

            current_duration_diff = Math.floor((now - moment(visit.actual_date_start + ' ' + visit.actual_time_start)) / 1000)
        }

        console.log(current_duration_diff);

        let computed_units = Math.floor((current_duration_diff) / (60 * 15))

        if (Math.floor((current_duration_diff) % (60 * 15)) >= 8 * 60) {
            computed_units++
        }

        let session_start_stop_button
        
        if(visit.date_start && visit.time_start){
            const scheduled_start_datetime = moment(visit.date_start + " " + visit.time_start)
            const now = moment()
            const two_hours_ago = now.clone().subtract(2, 'hours')
            const two_hours_in_the_future = now.clone().add(2, 'hours')
    
            if(this.state.isStarted && two_hours_ago <= scheduled_start_datetime && scheduled_start_datetime <= two_hours_in_the_future){
                session_start_stop_button = (
                    <Button variant="contained" fullWidth color="primary" onClick={this.handleStopButtonClick} disabled={this.state.isButtonDisabled || this.state.readonly}>
                        Stop
                    </Button>
                )
            }

            
            if(!this.state.isStarted && two_hours_ago <= scheduled_start_datetime && scheduled_start_datetime <= two_hours_in_the_future){
                session_start_stop_button = (
                    <Button variant="contained" fullWidth color="primary" onClick={this.handleStartButtonClick} disabled={this.state.isButtonDisabled || this.state.readonly}>
                        Start
                    </Button>
                )
            }
        }

        const extra_buttons = []

        // if(visit.actual_date_end && visit.actual_time_end){
        //     extra_buttons.push(<Button onClick={this.handleVisitSubmit} color="primary">Submit</Button>)
        // }

        if(visit.actual_date_start && visit.actual_time_start && !visit.actual_date_end && !visit.actual_time_end){
            extra_buttons.push(<Button onClick={this.handleVisitCancel} color="primary">Cancel</Button>)
        }
        // const title = 'Visit' + (process.env.REACT_APP_DEBUG === '1'? ' - ' + (visit.id || 'NEW'): '')
        const title = 'Visit - ' + visit.visit_state
        return (
            <React.Fragment>
                <FullScreenDialog
                    open={true}
                    title={title}
                    bodyPadding="20px"
                    handleClose={this.props.handleClose}
                    handleSave={this.handleSave}
                    extraButtons={extra_buttons}
                >
                    <ValidatorForm ref={this.form} onSubmit={this.handleSubmit}>
                        <Card className={classes.card}>
                            <Typography className={classes.cardTitle} color="textSecondary" gutterBottom>
                                Schedule
                        </Typography>
                            <div className={classes.cardDetails}>
                                <CardContent className={classes.cardContent}>
                                    <Grid container spacing={3}>
                                        <Grid item xs={12}>
                                            <FormControl fullWidth required>
                                                <InputLabel id="recipient-label" shrink={true}>Recipient</InputLabel>
                                                <SelectValidator
                                                    fullWidth
                                                    disabled={this.state.readonly}
                                                    name="recipient_id"
                                                    onChange={this.handleChange}
                                                    value={visit.recipient_id || ''}
                                                    validators={['required']}
                                                    errorMessages={['this field is required']}
                                                >
                                                    {recipientSelectElements}
                                                </SelectValidator>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <TextValidator
                                                required
                                                type="date"
                                                name="date_start"
                                                label="Date Start"
                                                disabled={this.state.readonly}
                                                onChange={this.handleChange}
                                                value={visit.date_start}
                                                fullWidth
                                                InputLabelProps={{ shrink: true }}
                                                validators={['required']}
                                                errorMessages={['this field is required']}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <TextValidator
                                                required
                                                type="time"
                                                name="time_start"
                                                label="Time Start"
                                                disabled={this.state.readonly}
                                                onChange={this.handleChange}
                                                value={visit.time_start}
                                                fullWidth
                                                InputLabelProps={{ shrink: true }}
                                                validators={['required']}
                                                errorMessages={['this field is required']}
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <TextValidator
                                                required
                                                type="number"
                                                name="units"
                                                label="Units"
                                                disabled={this.state.readonly}
                                                onChange={this.handleChange}
                                                value={visit.units}
                                                fullWidth
                                                InputLabelProps={{ shrink: true }}
                                                validators={['required']}
                                                errorMessages={['this field is required']}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <TextValidator
                                                required
                                                type="date"
                                                name="date_end"
                                                label="Date End"
                                                disabled={true}
                                                onChange={this.handleChange}
                                                value={visit.date_end}
                                                fullWidth
                                                InputLabelProps={{ shrink: true }}
                                                validators={['required']}
                                                errorMessages={['this field is required']}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <TextValidator
                                                required
                                                type="time"
                                                name="time_end"
                                                label="Time End"
                                                disabled={true}
                                                onChange={this.handleChange}
                                                value={visit.time_end}
                                                fullWidth
                                                InputLabelProps={{ shrink: true }}
                                                validators={['required']}
                                                errorMessages={['this field is required']}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <FormControl fullWidth required>
                                                <InputLabel id="recipient-label" shrink={true}>Address Start</InputLabel>
                                                <SelectValidator
                                                    fullWidth
                                                    disabled={this.state.readonly}
                                                    name="start_address_id"
                                                    onChange={this.handleChange}
                                                    value={visit.start_address_id || ''}
                                                    validators={['required']}
                                                    errorMessages={['this field is required']}
                                                >
                                                    {addressSelectElements}
                                                </SelectValidator>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <FormControl fullWidth required>
                                                <InputLabel id="recipient-label" shrink={true}>Address End</InputLabel>
                                                <SelectValidator
                                                    fullWidth
                                                    disabled={this.state.readonly}
                                                    name="end_address_id"
                                                    onChange={this.handleChange}
                                                    value={visit.end_address_id || ''}
                                                    validators={['required']}
                                                    errorMessages={['this field is required']}
                                                >
                                                    {addressSelectElements}
                                                </SelectValidator>
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </CardContent>
                            </div>
                        </Card>
                        <Card className={classes.card}>
                            <Typography className={classes.cardTitle} color="textSecondary" gutterBottom>
                                Current
                        </Typography>
                            <div className={classes.cardDetails}>
                                <CardContent className={classes.cardContent}>
                                    <Grid container spacing={3}>
                                        <Grid item xs={12} md={6}>
                                            <TextValidator
                                                type="date"
                                                name="actual_date_start"
                                                label="Actual Date Start"
                                                disabled={true}
                                                value={visit.actual_date_start}
                                                fullWidth
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <TextValidator
                                                type="time"
                                                name="actual_time_start"
                                                label="Actual Time Start"
                                                disabled={true}
                                                value={visit.actual_time_start}
                                                fullWidth
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <TextValidator
                                                type="text"
                                                name="actual_start_latitude"
                                                label="Actual Start Latitude"
                                                disabled={true}
                                                value={!isNaN(visit.actual_start_latitude) ? visit.actual_start_latitude : ''}
                                                fullWidth
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <TextValidator
                                                type="text"
                                                name="actual_start_longitude"
                                                label="Actual Start Longitude"
                                                disabled={true}
                                                value={!isNaN(visit.actual_start_longitude) ? visit.actual_start_longitude : ''}
                                                fullWidth
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <TextValidator
                                                type="date"
                                                name="actual_date_end"
                                                label="Actual Date End"
                                                disabled={true}
                                                value={visit.actual_date_end}
                                                fullWidth
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <TextValidator
                                                type="time"
                                                name="actual_time_end"
                                                label="Actual Time End"
                                                disabled={true}
                                                value={visit.actual_time_end}
                                                fullWidth
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <TextValidator
                                                type="text"
                                                name="actual_end_latitude"
                                                label="Actual End Latitude"
                                                disabled={true}
                                                value={!isNaN(visit.actual_end_latitude) ? visit.actual_end_latitude : ''}
                                                fullWidth
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <TextValidator
                                                type="text"
                                                name="actual_end_longitude"
                                                label="Actual End Longitude"
                                                disabled={true}
                                                value={!isNaN(visit.actual_end_longitude) ? visit.actual_end_longitude : ''}
                                                fullWidth
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            Duration: <b>{this.hhmmss(current_duration_diff)}</b>
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            Units: <b>{computed_units}</b>
                                        </Grid>
                                        <Grid item xs={12}>
                                            {session_start_stop_button}
                                        </Grid>
                                    </Grid>
                                </CardContent>
                                {/* <CardContent className={classes.cardContent}>
                                <Grid container spacing={1}>
                                    <Grid item xs={12} md={6}>
                                        Start: <b>{this.state.current_date_time_start ? this.state.current_date_time_start.format('YYYY-MM-DD HH:mm:ss') : ''}</b>
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        Location Start: <b>{this.state.current_location_start}</b>
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        End: <b>{this.state.current_date_time_end ? this.state.current_date_time_end.format('YYYY-MM-DD HH:mm:ss') : ''}</b>
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        Location End: <b>{this.state.current_location_end}</b>
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        Duration: <b>{this.hhmmss(duration_saved + this.state.current_duration_diff)}</b>
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        Units: <b>{computed_units}</b>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Button variant="contained" color="primary" onClick={this.handleStartStopButtonClick} disabled={this.state.isButtonDisabled || this.state.readonly}>
                                            {this.state.buttonText}
                                        </Button>
                                    </Grid>
                                </Grid>
                            </CardContent> */}
                            </div>
                        </Card>

                        <Card className={classes.card} ref={this.visit_caregiver_signature}>
                            <Typography className={classes.cardTitle} color="textSecondary" gutterBottom>
                                Caregiver's Signature
                        </Typography>
                            <div className={classes.cardDetails}>
                                <CardContent className={classes.cardContent}>
                                    <FormControl fullWidth required>
                                        <InputLabel id="caregiver-type-label" shrink={true}>Relation</InputLabel>
                                        <SelectValidator
                                            fullWidth
                                            disabled={this.state.readonly}
                                            name="recipient_signature_by_id"
                                            onChange={this.handleChange}
                                            value={visit.recipient_signature_by_id || ''}
                                            validators={['required']}
                                            errorMessages={['this field is required']}
                                        >
                                            {caregiverSignatureSelectElements}
                                        </SelectValidator>
                                    </FormControl>
                                </CardContent>
                            </div>
                            <SignatureField
                                name="visit_caregiver_signature"
                                onChange={this.handleChange}
                                value={visit.visit_caregiver_signature || ''}
                                disabled={this.state.readonly} />
                        </Card>
                        <Card className={classes.card} ref={this.provider_signature}>
                            <Typography className={classes.cardTitle} color="textSecondary" gutterBottom>
                                Provider's Signature
                        </Typography>
                            <SignatureField
                                name="provider_signature"
                                onChange={this.handleChange}
                                value={visit.provider_signature || ''}
                                disabled={this.state.readonly} />
                        </Card>

                    </ValidatorForm>
                </FullScreenDialog>
                {
                    this.state.is_validation_dialog_open? 
                    <ValidationProblemsDialog 
                        promise={this.state.validation_promise_handlers} 
                        problems={this.state.validation_problems}
                        handleClose={this.handleValidationProblemsDialogClose}
                        handleContinue={this.handle_validation_continue}
                        />: 
                    ''
                }
                {
                    this.state.is_confirmation_dialog_open? 
                    <ConfirmationDialog 
                        promise={this.state.confirmation_promise_handlers} 
                        handleClose={this.state.confirmation_promise_handlers.reject}
                        handleContinue={this.state.confirmation_promise_handlers.resolve}
                        />: 
                    ''
                }
            </React.Fragment>
         )
    }

    pad = (num) => {
        return ("0" + num).slice(-2);
    }
    hhmmss = (secs) => {
        var minutes = Math.floor(secs / 60);
        secs = secs % 60;
        var hours = Math.floor(minutes / 60)
        minutes = minutes % 60;
        return `${this.pad(hours)}:${this.pad(minutes)}:${this.pad(secs)}`;
    }
}

export default withStyles(styles)(VisitForm);